import type { AppProps, AppContext } from "next/app";
import "@/styles/globals.css";
import { StoreProvider } from "easy-peasy";
import store from "@/store";
import AppLogic from "./appLogic";

import("@meitu/xdesign-widgets/dist/teamExports").then(
  ({ initResignedListener }) => {
    initResignedListener();
  }
);

const MyApp = ({
  Component,
  pageProps,
}: AppProps & { isPersonal: boolean }) => {
  return (
    <StoreProvider store={store}>
      <AppLogic />
      <Component {...pageProps} />
    </StoreProvider>
  );
};

export default MyApp;
